<template>
    <!-- Container para toda la página: ******************************************************* -->
    <v-container fill-height fluid class="busqueda">
        <!-- Layout para toda la página: *********************************************************** -->
        <v-layout align-center justify-center>
            <!-- Flex para la ventana: **************************************************************** -->
            <v-flex xs12 sm10 elevation-6>
                <div class="sub-window">
                    <v-toolbar dense dark color="teal darken-3">
                        <v-toolbar-title>
                            <v-icon>mdi-magnify</v-icon>&nbsp; Búsqueda de
                            Encuestas
                        </v-toolbar-title>
                        <v-spacer></v-spacer>
                        <v-toolbar-items class="hidden-sm-and-down">
                            <v-menu offset-y>
                                <template v-slot:activator="{ on }">
                                    <v-btn text class="text-none" v-on="on"
                                        >Encuesta</v-btn
                                    >
                                </template>
                            </v-menu>
                            <v-tooltip bottom>
                                <template v-slot:activator="{ on }">
                                    <v-btn text @click="onClose" v-on="on">
                                        <v-icon>mdi-close</v-icon>
                                    </v-btn>
                                </template>
                                <span>Cerrar</span>
                            </v-tooltip>
                        </v-toolbar-items>

                        <!-- Menú lateral para dispositivos con ventanas chicas: -->
                        <v-menu bottom left>
                            <template v-slot:activator="{ on }">
                                <v-btn icon v-on="on" class="hidden-md-and-up">
                                    <v-icon>mdi-dots-vertical</v-icon>
                                </v-btn>
                            </template>
                            <v-list color="grey lighten-5">
                                <v-divider></v-divider>
                                <v-list-item @click="onClose">
                                    <v-list-item-title>
                                        <v-icon color="red">mdi-close</v-icon
                                        >&nbsp; Cerrar
                                    </v-list-item-title>
                                </v-list-item>
                            </v-list>
                        </v-menu>
                    </v-toolbar>

                    <!-- Container para todos los campos de la ventana: -->
                    <v-container grid-list-md>
                        <v-layout wrap align-center row>
                            <v-flex xs4 sm4 md3 d-flex>
                                <v-select
                                    v-model="selectedLanguage"
                                    :items="languages"
                                    item-text="language"
                                    item-value="id"
                                    label="Idioma"
                                    dense
                                    return-object
                                    clearable
                                    @change="onSelectLanguage"
                                    color="teal darken-3"
                                    item-color="teal darken-2"
                                ></v-select>
                            </v-flex>
                            <v-flex xs4 sm4 md3 d-flex offset-md1>
                                <v-select
                                    dense
                                    v-model="selectedSearchType"
                                    :items="searchTypes"
                                    item-text="type"
                                    item-value="id"
                                    label="Tipo de Búsqueda"
                                    return-object
                                    clearable
                                    color="teal darken-3"
                                    item-color="teal darken-2"
                                ></v-select>
                            </v-flex>
                            <v-flex xs4 sm4 md3 d-flex offset-md1>
                                <v-select
                                    dense
                                    v-model="questionnaireType"
                                    :items="questionnaireTypes"
                                    item-text="questionnaire"
                                    item-value="id"
                                    label="Tipo de Encuesta"
                                    return-object
                                    clearable
                                    color="teal darken-3"
                                    item-color="teal darken-2"
                                ></v-select>
                            </v-flex>
                        </v-layout>

                        <v-layout wrap row align-center>
                            <v-flex xs6>
                                <v-radio-group dense v-model="bMassive" row>
                                    <v-radio
                                        label="Encuesta Personal"
                                        value="radio-1"
                                        color="orange accent-4"
                                    ></v-radio>
                                    <v-radio
                                        label="Encuesta Masiva"
                                        value="radio-2"
                                        color="orange accent-4"
                                    ></v-radio>
                                </v-radio-group>
                            </v-flex>
                            <v-flex xs6>
                                <v-btn
                                    color="green darken-3"
                                    class="text-none"
                                    text
                                    :disabled="waitCursor"
                                    @click="onSearch"
                                >
                                    Buscar&nbsp;
                                    <v-icon color="green darken-3"
                                        >mdi-magnify</v-icon
                                    >
                                </v-btn>
                                <v-btn
                                    color="green darken-3"
                                    class="text-none"
                                    text
                                    :disabled="waitCursor"
                                    @click="onClearParameters"
                                >
                                    Limpiar parámetros&nbsp;
                                    <v-icon color="green darken-3"
                                        >mdi-autorenew</v-icon
                                    >
                                </v-btn>
                                <v-btn
                                    color="green darken-3"
                                    class="text-none"
                                    text
                                    :disabled="waitCursor"
                                    @click="onClearResults"
                                >
                                    Limpiar resultados&nbsp;
                                    <v-icon color="green darken-3"
                                        >mdi-notification-clear-all</v-icon
                                    >
                                </v-btn>
                            </v-flex>
                        </v-layout>

                        <v-layout wrap row>
                            <v-flex xs12 color="red">
                                <v-data-table
                                    :headers="headers"
                                    :items="carSearchResults"
                                    show-select
                                    item-key="id"
                                    class="elevation-1"
                                    dense
                                    fixed-header
                                    height="300px"
                                    :loading="waitCursor"
                                    loading-text="Cargando resultados de búsqueda..."
                                    v-model="selectedQuestionnaires"
                                    locale="es-MX"
                                    :items-per-page="30"
                                    no-data-text="No hay encuestas con los criterios de búsqueda seleccionados."
                                    :footer-props="{
                                        showFirstLastPage: true,
                                        'items-per-page-text':
                                            'Encuestas por página:',
                                        'items-per-page-all-text': 'Todos',
                                    }"
                                    @item-selected="onSelectQuestionnaire"
                                >
                                    <!-- <template slot="item" slot-scope="props">
                            <tr @click="onCarClick">
                              <td>
                                <v-checkbox :v-model="props.item.isSelected"></v-checkbox>
                              </td>
                              <td>{{ props.item.brand }}</td>
                            </tr>
                                    </template>-->
                                </v-data-table>
                            </v-flex>
                        </v-layout>

                        <!-- **************   Modal para pedir al menos un parámetro para realizar una búsqueda: ***********************  -->
                        <v-layout row justify-center>
                            <v-dialog
                                v-model="bModalWarning"
                                persistent
                                :width="modalWidth"
                            >
                                <v-card class="grey lighten-2">
                                    <v-toolbar
                                        dense
                                        color="blue darken-2"
                                        dark
                                        flat
                                    >
                                        <v-toolbar-title class="my-list-title"
                                            >Búsqueda de
                                            Automóviles</v-toolbar-title
                                        >
                                        <v-spacer></v-spacer>
                                        <v-icon>warning</v-icon>
                                    </v-toolbar>
                                    <v-card-title class="text-center">
                                        <v-container>
                                            <v-layout row>
                                                <v-flex
                                                    xs12
                                                    class="d-flex justify-center"
                                                >
                                                    <v-icon
                                                        large
                                                        color="orange darken-2"
                                                        >error</v-icon
                                                    >
                                                </v-flex>
                                            </v-layout>
                                            <v-layout row>
                                                <v-flex
                                                    xs12
                                                    class="d-flex justify-center"
                                                    >Introduzca un parámetro
                                                    para realizar una
                                                    búsqueda.</v-flex
                                                >
                                            </v-layout>
                                        </v-container>
                                    </v-card-title>

                                    <v-card-actions>
                                        <v-spacer></v-spacer>
                                        <v-btn
                                            color="green darken-3"
                                            class="text-none"
                                            text
                                            @click="bModalWarning = false"
                                            >OK</v-btn
                                        >
                                    </v-card-actions>
                                </v-card>
                            </v-dialog>
                        </v-layout>
                        <!-- **************   Fin Modal para pedir al menos un parámetro para realizar una búsqueda ***********************  -->
                    </v-container>
                </div>
            </v-flex>
        </v-layout>

        <v-overlay :value="waitCursor">
            <v-progress-circular
                indeterminate
                size="64"
                color="primary"
            ></v-progress-circular>
        </v-overlay>
    </v-container>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
    name: 'Busqueda',
    data() {
        return {
            drawer: false,
            bModalWarning: false, //Para mostrar el modal que indica que se debe poner al menos un parámetro para poder hacer una búsqueda.
            bModalMessage: false, //Para mostrar el modal para mandar mensaje a los coches seleccionados.
            selectedQuestionnaires: [],
            bEmail: false,
            bAppMessage: false,

            selectedLanguage: null,
            selectedSearchType: null,

            headers: [
                { text: 'Marca', value: 'brand' },
                { text: 'Submarca', value: 'subBrand' },
                { text: 'Modelo', value: 'model' },
                { text: 'Placas', value: 'plates' },
                { text: 'Motor', value: 'motor' },
                { text: 'Serie', value: 'series' },
                { text: 'Tipo de Venta', value: 'salesType' },
                { text: 'Subtipo de Venta', value: 'salesSubType' },
                { text: 'Monto', value: 'monto' },
                { text: 'Garantía', value: 'warrantyDate' },
            ],

            searchTypes: [
                {
                    id: 1,
                    type: 'Por tipo',
                },
                {
                    id: 2,
                    type: 'Por empresa',
                },
                {
                    id: 3,
                    type: 'Por encuestado',
                },
            ],
        };
    },
    components: {},
    created() {
        this.initCarSearchFields();
        c;
    },
    methods: {
        ...mapActions([
            'initCarSearchFields',
            'carSearch',
            'clearCarSearchResults',
            'updateClientCarID',
        ]),
        onClose() {
            this.$router.push('/');
        },
        onSelectLanguage() {
            console.log('onSelectLanguage, ', this.selectedLanguage);
        },
        onSelectQuestionnaire() {
            console.log('onSelectQuestionnaire');
        },
        onSelectSaleType() {
            console.log('selectedSaleType = ', this.selectedSaleType);
            if (
                this.selectedSaleType === undefined ||
                this.selectedSaleType === null
            ) {
                this.$store.dispatch('emptySaleSubTypes');
            } else {
                this.$store.dispatch(
                    'getSaleSubTypes',
                    this.selectedSaleType.id
                );
            }
        },

        onAutomoviles() {
            console.log('OnAutomoviles');
        },
        onClearParameters() {
            this.selectedQuestionnaires = [];
            this.selectedLanguage = null;
            //this.$store.dispatch('emptyCarSubBrands');

            this.selectedSaleType = null;
            this.$store.dispatch('emptySaleSubTypes');
            this.selectedSaleSubType = null;
            this.model = '';
            this.plates = '';
            this.motor = '';
            this.series = '';
            this.ammountType = '';
            this.creditAmmount = '';
            this.bAmmount = false;
            this.bCreditExpired = false;
            this.bCreditExpiredDate = false;
            this.creditStatus = '';
            this.creditExpirationType = '';
        },
        onClearResults() {
            this.clearCarSearchResults();
        },
        onAmmountTypeChanged() {
            if (this.ammountType === undefined) {
                this.bAmmount = false;
            } else {
                this.bAmmount = true;
            }
        },
        onCreditStatusChanged() {
            if (
                this.creditStatus === undefined ||
                this.creditStatus === 'Vigente'
            ) {
                this.bCreditExpired = false;
                this.bCreditExpiredDate = false;
                this.creditExpirationType = '';
            } else {
                this.bCreditExpired = true;
            }
            console.log('creditStatus = ' + this.creditStatus);
            console.log('creditExpirationType = ' + this.creditExpirationType);
        },
        onCreditExpirationTypeChanged() {
            if (this.creditExpirationType === 'entre') {
                this.bCreditExpiredDate = true;
            } else {
                this.bCreditExpiredDate = false;
            }
        },
        onWarrantyStatusChanged() {
            if (
                this.warrantyStatus === undefined ||
                this.warrantyStatus == 'Vigente'
            ) {
                console.log('GarantiaFin = ' + this.bWarrantyEnded);
                this.bWarrantyEnded = false;
                this.bWarrantyEndedDate = false;
                this.warrantyExpirationType = '';
            } else {
                this.bWarrantyEnded = true;
            }
        },
        onInsuranceStatusChanged() {
            if (
                this.insuranceStatus === undefined ||
                this.insuranceStatus === 1
            ) {
                //'Vigente'
                console.log('SeguroFin = ' + this.bInsuranceEnded);
                this.bInsuranceEnded = false;
                this.bInsuranceEndedDate = false;
                this.insuranceExpirationType = '';
            } else {
                this.bInsuranceEnded = true;
            }
        },
        onWarrantyExpirationTypeChanged() {
            if (this.warrantyExpirationType == 'entre') {
                this.bWarrantyEndedDate = true;
            } else {
                this.bWarrantyEndedDate = false;
            }
        },
        onInsuranceExpirationTypeChanged() {
            if (this.insuranceExpirationType == 'entre') {
                this.bInsuranceEndedDate = true;
            } else {
                this.bInsuranceEndedDate = false;
            }
        },
        onSearch() {
            var strBrand;
            var bSearch = false; //Indica si al menos hay un parámetro de búsqueda.

            console.log('selectedLanguage = ', this.selectedLanguage);

            // const searchString =
            //     strBrand +
            //     '/' +
            //     strSubBrand +
            //     '/' +
            //     strModel +
            //     '/' +
            //     strPlates +
            //     '/' +
            //     strMotor +
            //     '/' +
            //     strSeries;

            //console.log('searchString = ', searchString);

            // if (bSearch) {
            //     this.carSearch(searchString);
            // } else {
            //     this.bModalWarning = true;
            // }
        },

        onCarClick() {
            console.log('onCarClick');
        },
        onCancelMessage() {
            this.bModalMessage = false;
        },
    },
    computed: {
        ...mapGetters([
            'languages',
            'carSubBrands',
            'saleTypes',
            'saleSubTypes',
            'ammountTypes',
            'creditStates',
            'expirationTypes',
            'warrantyStates',
            'warrantyTypes',
            'carSearchResults',
            'insuranceCompanies',
            'insuranceStates',
            'waitCursor',
        ]),

        modalWidth() {
            var width = '100%';
            if (this.$vuetify.breakpoint.xs) {
                width = '80%';
            } else if (this.$vuetify.breakpoint.sm) {
                width = '60%';
            } else if (this.$vuetify.breakpoint.md) {
                width = '40%';
            } else if (this.$vuetify.breakpoint.lg) {
                width = '30%';
            } else if (this.$vuetify.breakpoint.xl) {
                width = '20%';
            }
            return width;
        },
    },
};
</script>

<style scoped>
.sub-window {
    /* background-color: #eeeeee; */
    /*grey lighten-3 */
    background: rgba(224, 224, 224, 0.8);
}
.busqueda {
    /* background: url('../assets/christina-wocintechchat-com-faEfWCdOKIg-unsplash.jpg'); */
    background: url('../assets/mainbackground.jpg');
    background-size: cover;
    width: 100%;
    height: 100%;
}

/* ***************Modificaciones para que no se parta el texto en v-card-text y en v-card-title (al parecer es un bug de vuetify):************* */
.v-card__text,
.v-card__title {
    word-break: normal; /* maybe !important  */
}
</style>